import * as React from "react";

const CrossSvg = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 24 24"
    >
        <path
            d="M7.68 18 12 13.68 16.32 18 18 16.32 13.68 12 18 7.68 16.32 6 12 10.32 7.68 6 6 7.68 10.32 12 6 16.32zM12 24q-2.49 0-4.68-.945a12.1 12.1 0 0 1-3.81-2.565 12.1 12.1 0 0 1-2.565-3.81Q0 14.49 0 12t.945-4.68T3.51 3.51A12.1 12.1 0 0 1 7.32.945Q9.51 0 12 0t4.68.945 3.81 2.565a12.1 12.1 0 0 1 2.565 3.81Q24 9.51 24 12t-.945 4.68a12.1 12.1 0 0 1-2.565 3.81 12.1 12.1 0 0 1-3.81 2.565Q14.49 24 12 24m0-2.4q4.02 0 6.81-2.79T21.6 12t-2.79-6.81T12 2.4 5.19 5.19 2.4 12t2.79 6.81T12 21.6"
        ></path>
    </svg>
);

export default CrossSvg;
